import React, { useState } from "react";

import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import clsx from "clsx";

export const SearchResultsHeader = ({ settings }) => {

  const params = new URLSearchParams(window.location.search);
  const query = params.get("q");

  if (!query) return null;

  const {
    heading_type_desktop,
    heading_type_mobile,
    subheading,
    subheading_type_desktop,
    subheading_type_mobile,
    pill_products_label,
    pill_articles_label
  } = settings.section_settings;

  const pills = [
    {
      label: pill_products_label || 'Shop',
      value: 'products'
    },
    {
      label: pill_articles_label || 'Blog',
      value: 'articles'
    }
  ];

  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint || '1024px');
  const [activePill, setActivePill] = useState(pills[0].value);

  function handlePillClick(pill) {
    setActivePill(pill);

    const event = new CustomEvent("search-results-pill-clicked", { detail: pill });
    window.dispatchEvent(event);
  }

  return (
    <div className="flex max-lg:flex-col lg:justify-between gap-4">
      <div className="flex flex-col gap-2">
        <p className={isMobile ? subheading_type_mobile : subheading_type_desktop}>
          {subheading || 'Search results for:'}
        </p>

        <p className={isMobile ? heading_type_mobile : heading_type_desktop}>
          {query}
        </p>
      </div>

      <div className="flex-1 flex justify-end items-end">
        <div className="flex gap-1 items-center border border-black rounded-full p-1 w-full max-w-[400px] bg-white">
          {pills.map((pill) => (
            <div
              key={pill.value}
              className={clsx("b3--bold flex items-center justify-center rounded-full px-5 min-h-[55px] flex-1 cursor-pointer transition-colors", {
                'bg-white text-black': activePill !== pill.value,
                'bg-black text-white': activePill === pill.value,
              })}
              onClick={() => handlePillClick(pill.value)}
            >
              {pill.label}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SearchResultsHeader;
